import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Subject } from "rxjs";
import {BsModalRef} from "ngx-bootstrap";
declare var MediaElementPlayer: any;
@Component({
    selector: 'app-view-defects',
    templateUrl: './view-defects.component.html',
    styleUrls: [ 'view-defects.component.scss' ]
})

export class ViewDefectsComponent implements OnInit {

    onClose: Subject<any>;
    defect: any;
    defectStages: any[]
    selectedStage: any;
    imageUrl: string;
    title:string;
    currentIndex: number = 0;
    private keyListener = (event: KeyboardEvent) => {};
    constructor(public bsModalRef: BsModalRef) {
    }

    ngOnInit() {  
        this.onClose = new Subject();
        if(this.defectStages && this.defectStages.length) {
            this.selectedStage = this.defectStages.find((stage) => stage.id == this.defect.currentStage)
        } else {
            this.selectedStage = {
                id: this.defect.currentStageId,
                name: this.defect.currentStage,
                color: this.defect.stagecolor
            }
        }
        this.title = this.defect.issueType == 'defects' ? 'Defect details' : 'Recommendation details';
        this.imageUrl = this.defect && this.defect.defectImages && this.defect.defectImages[0] || null;
        if (this.defect.defectImages && this.defect.defectImages.length) {
            this.currentIndex = 0;
            document.body.classList.add('defect-media-mode');
        }
        this.keyListener = (event: KeyboardEvent) => {
            if (this.defect && this.defect.defectImages && !this.defect.defectImages.length) return;
      
            if (event.key === 'ArrowRight') {
              this.showNextImage();
            }
      
            if (event.key === 'ArrowLeft') {
              this.showPreviousImage();
            }
        };
        window.addEventListener('keydown', this.keyListener);  
    }
    
    close() {
        this.bsModalRef.hide();
        this.onClose.next();
        setTimeout(() => {
            document.body.classList.remove('defect-media-mode');
        },250)
        
    }

    async downloadImg(imageSrc){
        const image = await fetch(imageSrc);
        const imageBlog = await image.blob();
        const imageURL = URL.createObjectURL(imageBlog);
        const link = document.createElement('a');
        link.href = imageURL;
        link.download = imageSrc.split('/').pop();
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    changeDefaultImage(url) {
        this.imageUrl = url;
        this.currentIndex = this.defect.defectImages.indexOf(url);
    }

    ngOnDestroy() {
        window.removeEventListener('keydown', this.keyListener);
        setTimeout(() => {
            document.body.classList.remove('defect-media-mode');
        },250)
    }

    showNextImage() {
        if (!this.defect.defectImages.length) return;
      
        this.currentIndex =
          (this.currentIndex + 1) % this.defect.defectImages.length;
      
        this.imageUrl = this.defect.defectImages[this.currentIndex];
    }
      
    showPreviousImage() {
        if (!this.defect.defectImages.length) return;
        this.currentIndex =
            (this.currentIndex - 1 + this.defect.defectImages.length) %
            this.defect.defectImages.length;
        
        this.imageUrl = this.defect.defectImages[this.currentIndex];
    }
}
